import { isoStringRegex } from '@shared/constants/regex.const';

export const validDate = (value: string | Date): boolean => {
    const regexPassed = isoStringRegex.test(value instanceof Date ? value.toISOString() : value);
    if (!regexPassed) {
        return false;
    }
    const testDate = new Date(value);
    const validTime = !isNaN(testDate.getTime());
    const validISOConversion = testDate.toISOString() === (value instanceof Date ? value.toISOString() : value);
    return validTime && validISOConversion;
};
